import mediaQuery from 'common/config/theme/app/functions/mediaQuery'
import * as mixins from 'common/config/theme/app/functions/mixins'

export const colors = {
  white: '#ffffff',
  black: '#000000',
  lightBlack: '#282828',
  darkGray: '#31353e',
  lightBlue: '#e6fafa',
  darkBlue: '#405264',
  brightBlue: '#2e4ad4',
  blueGray: '#727F97',
  navyBlue: '#0b037a',
  royalBlue: '#4436eb',
  aliceBlue: '#f3f5f7',
  paleNavy: '#eef9fe',
  orange: '#ffa800',
  red: '#F45C65',
  brightRed: '#fd4a71',
  mediumPurple: '#7068df',
  lightPurple: '#b7b3ee',
  lightYellow: '#f8ffdd',
  yellowGreen: '#CAFF0A',
  green: '#89CF82',

  brand: '#00CACD',
  primary: '#e9e9e9',
  secondary: '#8E8E8C',
  background: '#202121',
  backgroundLite: '#1a1a1a',
  borderColor: '#ece6e71a',
  // darkGray: '#e9e9e9',
  // gray: '#727F97',
  // white: '#3c4351',
  // lightGray: '#393D46',
  // ash: '#474f5f',

  warning: '#fd4a71',
  success: '#3cb371',
  info: '#0275d8',
}

export const fonts = {
  code: "'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default",
  text: "'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default",
}

export const functions = {
  mediaQuery,
  mixins,
}

export const layout = {
  sidebar: false,
}
